import { makeStyles } from '@material-ui/core/styles';
import { COLORS } from 'config/theme/baseTheme';

export const useStyles = makeStyles((theme) => ({
  dialogPaper: {
    minWidth: '600px',
    maxWidth: '700px',
  },
  dialogTitle: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    padding: theme.spacing(3),
    paddingBottom: theme.spacing(2),
    backgroundColor: COLORS.WHITE,
    position: 'relative',
    '& h2': {
      fontSize: '20px',
      fontWeight: 700,
      paddingRight: theme.spacing(4),
    },
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(2),
    top: theme.spacing(2),
    color: theme.palette.grey[500],
  },
  titleDescription: {
    fontSize: '12px',
    color: theme.palette.text.secondary,
    fontWeight: 400,
  },
  courierSelected: {
    fontSize: '12px',
    marginBottom: '8px',
    marginLeft: '8px',
    '& span':{
      fontSize: '14px',
      fontWeight: 700,
    }
  },
  dialogContent: {
    padding: theme.spacing(1.5),
    backgroundColor: COLORS.CATSKILL_WHITE_LIGHT,
  },
  sectionCard: {
    backgroundColor: COLORS.WHITE,
    borderRadius: '8px',
    padding: theme.spacing(1.5),
  },
  sectionHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(1.5),
  },
  sectionHeaderTop: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(1),
  },
  sectionTitle: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    fontWeight: 700,
    fontSize: '14px',
    '& .MuiTypography-root': {
      fontWeight: 700,
      fontSize: '14px',
    },
  },
  sectionCount: {
    fontWeight: 600,
    fontSize: '12px',
    backgroundColor: COLORS.F3F4F6,
    padding: theme.spacing(0.5, 1.5),
    borderRadius: '4px',
  },
  successIcon: {
    width: '16px',
    height: '16px',
    color: '#10B981',
  },
  icon: {
    width: '16px',
    height: '16px',
  },
  description: {
    fontSize: '12px',
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(0),
    paddingBottom: theme.spacing(1.5),
    paddingLeft: theme.spacing(2.5),
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  descriptionError: {
    fontSize: '12px',
    color: '#DC2626',
    marginBottom: theme.spacing(0),
    paddingBottom: theme.spacing(1.5),
    paddingLeft: theme.spacing(2.5),
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  consignmentIdsLabel: {
    fontSize: '12px',
    fontWeight: 600,
    color: '#374151',
    marginBottom: theme.spacing(1),
  },
  chipsContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
  chipsWrapper: {
    width: '100%',
    overflow: 'hidden',
  },
  chip: {
    borderRadius: '4px',
    height: '28px',
    backgroundColor: COLORS.F3F4F6,
    borderColor: COLORS.E5E7EB,
    color: COLORS.BG4B5563,
  },
  toggleButton: {
    textTransform: 'none',
    padding: 0,
    minWidth: 'auto',
    fontSize: '14px',
    fontWeight: 500,
  },
  dialogActions: {
    borderTop: `1px solid ${theme.palette.divider}`,
    padding: theme.spacing(2),
    justifyContent: 'flex-end',
    gap: theme.spacing(1.5),
    backgroundColor: COLORS.WHITE,
  },
  actionButton: {
    borderRadius: '6px',
    minWidth: '120px',
    textTransform: 'none',
    height: '36px',
  },
}));
